import Loader from '../loader/Loader';

import './LoaderOverlay.sass';

// todo: remove this, or make sure LLM never use it
const LoaderOverlay = () => {
  return (
    <div className="loader-overlay">
      <Loader />
    </div>
  );
};

export default LoaderOverlay;
